<!--
  NP Šumava, kůrovcové souše - doplňková mapová nástrojová nabídka 
-->
<template>

  <div class="d-flex flex-row">

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="MapPnlGrdItem elevation-5" width="40" min-width="40" min-height="40" color="info" v-bind="attrs"
          v-on="on" @click="MapLayerLegendDynamicSet()">
          <v-icon>mdi-map-legend</v-icon>
        </v-btn>
      </template>
      <span class="">Legenda</span>
    </v-tooltip>

    <v-card height="40" color="info" class="MapPnlGrdItem elevation-5">
      <v-card-title class="text-body-1 py-2">NP Šumava - kůrovcové souše</v-card-title>
    </v-card>

    <Teleport to="#MapLayerLegendDynamicObj" v-if="ViewLeg">

      <!-- Legenda s výběrem ( zobrazeno v měřítku pod VybLeg.EditableMinScale) -->
      <v-list dense v-if="MapScale < VybLeg.EditableMinScale" color="transparent">
        <v-list-item-group multiple mandatory v-model="VybLegList" color="primary">
          <v-list-item v-for="(item) in VybLeg.Seznam" :key="item.Kod" :value="item.Kod">

            <!-- Se šrafou -->
            <v-list-item-avatar v-if="item.Srafa" class="my-1" rounded color="transparent">
              <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg" :color="item.Barva">
                <defs>
                  <!-- definice výplně - šrafy -->
                  <pattern :id="'pt_' + item.Kod" :width="item.Srafa.PatternWidth" :height="item.Srafa.PatternHeight"
                    patternUnits="userSpaceOnUse">
                    <path :d="item.Srafa.Pathd" style="stroke:currentColor"
                      :style="{ 'stroke-width': item.Srafa.PathdStyleStrokeWidth }">
                    </path>
                  </pattern>
                </defs>
                <!-- případná barva podkladu -->
                <rect width="100%" height="100%" :fill="item.Srafa.BarvaPodklad" v-if="item.Srafa.BarvaPodklad" />
                <!-- výplň - šrafa -->
                <rect width="100" height="100" :fill="'url(#pt_' + item.Kod + ')'" />
              </svg>
            </v-list-item-avatar>

            <!-- Bez šrafy -->
            <v-list-item-avatar v-else class="my-1" rounded :color="item.Barva" />

            <v-list-item-title v-text="item.Popis" class="white--text"></v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <!-- Legenda bez výběru ( zobrazeno v měřítku nad VybLeg.EditableMinScale)  -->
      <v-list dense v-else color="transparent">

        <v-list-item v-for="item in VybLeg.Seznam" :key="item.Kod">

          <!-- Se šrafou -->
          <v-list-item-avatar v-if="item.Srafa" class="my-1" rounded color="transparent">
            <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg" :color="item.Barva">
              <defs>
                <!-- definice výplně - šrafy -->
                <pattern :id="'pt_' + item.Kod" :width="item.Srafa.PatternWidth" :height="item.Srafa.PatternHeight"
                  patternUnits="userSpaceOnUse">
                  <path :d="item.Srafa.Pathd" style="stroke:currentColor"
                    :style="{ 'stroke-width': item.Srafa.PathdStyleStrokeWidth }">
                  </path>
                </pattern>
              </defs>
              <!-- případná barva podkladu -->
              <rect width="100%" height="100%" :fill="item.Srafa.BarvaPodklad" v-if="item.Srafa.BarvaPodklad" />
              <!-- výplň - šrafa -->
              <rect width="100" height="100" :fill="'url(#pt_' + item.Kod + ')'" />
            </svg>
          </v-list-item-avatar>

          <!-- Bez šrafy -->
          <v-list-item-avatar v-else class="my-1" rounded :color="item.Barva" />

          <v-list-item-title v-text="item.Popis"></v-list-item-title>
        </v-list-item>

      </v-list>

    </Teleport>



  </div>
</template>

<script>
import AppDataKrvc from "../../../assets/MapOt_Krvc.json";
import { eq, or, literal, property, toFeaturePredicate } from "@luciad/ria/ogc/filter/FilterFactory";

export default {

  components: {
    Teleport: () => import("vue2-teleport")
  },


  props: {
    // Adresa na Assets
    AssetsUrl: null,
    // Mapa (Luciad)
    MAP: Object,
    // Měřítko vztažené k rovníku
    MapScale: null,
    // Mapové vrstvy
    MapLegendLayers: null,
    // Jméno zobrazené dynamické legendy
    MapLayerLegendDynamic_content: {},
  },

  data() {
    return {
      // Jestli je nástroj inicializován
      IsInit: false,
      // Legenda
      VybLeg: null,
      // Vybrané prvky legendy
      VybLegList: [],

      // Viditelnost legendy
      ViewLeg: false,

      // Jméno legendy
      MapLayerLegendDynamic_contentName: "MapOT_Krvc_legend",
      MapLayerLegendDynamic_Title: "NP Šumava<br/>Kůrovcové souše - ročník",

    };
  },



  computed: {
    // Vrstva LayerGroup z mapy určené pro KRVC
    MapLayer_Uhul_krvc: function () {
      return this.MapLegendLayers.find((item) => item.id == "Uhul_krvc");
    },
    // Podřízená vrstvy - wfs
    MapLayer_Uhul_krvc_wfs: function () {
      return this.MapLegendLayers.find((item) => item.id == "Uhul_krvc_wfs");
    },

    // wfs vrstva - filter podle výběru
    MapLayer_Uhul_krvc_wfs_Filter: function () {
      if (this.VybLeg.Seznam.length == this.VybLegList.length) {
        // Všechny položky
        return null

      } else if (this.VybLegList.length == 1) {
        // Jedna položka
        return toFeaturePredicate(eq(property(this.VybLeg.Polozka), literal(this.VybLegList[0])));

      } else {

        var _this = this;
        var filters = this.VybLegList.map(function (l) {
          return (eq(property(_this.VybLeg.Polozka), literal(l)))
        })

        return toFeaturePredicate(or(...filters));
      }
    },




  },

  watch: {

    // Změna zobrazení jednotlivých objektů v legendě
    VybLegList: function () {
      this.MapLayer_Uhul_krvc_wfs.layer.filter = this.MapLayer_Uhul_krvc_wfs_Filter;
    },

    // Změna zobrazení vlastní legendylegendy
    MapLayerLegendDynamic_content: function (value) {
      // console.log("MapLayerLegendDynamic_content")
      // console.log(value)
      if (value == this.MapLayerLegendDynamic_contentName) { this.ViewLeg = true } else { this.ViewLeg = false }
    },

  },

  methods: {
    // Zobrazení dynamické mapové legendy - volá se funkce v nadřazeném objektu
    MapLayerLegendDynamicSet: function () {
      //console.log("MapLayerLegendDynamicSet")
      this.$emit('MapLayerLegendDynamicSet', this.MapLayer_Uhul_krvc.id, this.MapLayerLegendDynamic_Title, this.MapLayerLegendDynamic_contentName);
    },

  },

  mounted() {
    // První spuštění nástroje
    //console.log("KRVC start");

    // Základní nastavení - 
    // Načtení legendy
    this.VybLeg = AppDataKrvc.Legenda;
    // Vybrat vše v legendě
    this.VybLegList = this.VybLeg.Seznam.map(function (l) {
      return l.Kod
    })

    // Objekt aktivován
    this.MAP.layerTree.whenReady().then(() => { this.IsInit = true; })

    // // Legenda vrstvy
    // this.MapLayerLegendDynamicAdd()

  },
};
</script>